﻿module.exports = (function ($, mustache, urlParameters) {
    return {
        hasResults: false,
        init: function () {
            // Used to reference 'this' inside anonymous functions (e.g. click events)

            var self = this;
            var meDbOutcomesSearch = $("#meDbOutcomesSearch").length > 0;
            if (meDbOutcomesSearch) {
                this.initSearchForm();
            }

            var meDbOutcomesSearchResults = $("#meDbOutcomesSearchResults").length > 0;
            if (meDbOutcomesSearchResults) {
                this.initSearchResultsForm();
                this.initTabs();
            }

            $(window).resize(function () {
                $('.select2').css('width', "100%");
            });

        },
        toggleFilters: function(){

            var self = this;

            $('.meDbSearch__row').slideToggle();

            $('#hide_show_filters').toggleClass('hide');
            if ($('#hide_show_filters').hasClass('hide'))
                $('#hide_show_filters').text('Show Filters');
            else
                $('#hide_show_filters').text('Hide Filters');
        },
        initSearchForm: function () {
            var self = this;
            var resultData = null;
            // get field loader data from API cached calls.
            $.ajax({
                url: '/umbraco/surface/medb/outcomessearchmetadata',
                type: 'GET',
                dataType: 'json',
                success: function (data) {
                    // load select lists.
                    console.log(data)
                    resultData = data;

                    // Load the domains
                    var domains = $('#domains');
                    var domainsToggle = $('#domainsToggle');
                    domainsToggle.click(function () {
                        if (!domains.is(':hidden')) {
                            domainsToggle.removeClass('show').addClass('hide').text('Show Outcomes');
                            domains.hide();
                        }
                        else if (domains.is(':hidden')) {
                            domainsToggle.removeClass('hide').addClass('show').text('Hide Outcomes');
                            domains.show();
                        }
                    });
                    var filters = $('#filters');
                    var filtersToggle = $('#filtersToggle');
                    filtersToggle.click(function () {
                        if (!filters.is(':hidden')) {
                            filtersToggle.removeClass('show').addClass('hide').text('Show Filters');
                            filters.hide();
                        }
                        else if (filters.is(':hidden')) {
                            filtersToggle.removeClass('hide').addClass('show').text('Hide Filters');
                            filters.show();
                        }
                    });
                    domains.empty();

                    var template = $('.meDbOutcomesSearch__form script:first').html();
                    mustache.parse(template);
                    var rendered = mustache.render(template, {
                        domains: resultData.domains,
                        "getInstruction": function () {
                            return function (text, render) {
                                return "<b>" + render(text) + "</b>";
                            }
                        },
                        "getHeading": function () {
                            return function (text, render) {
                                return "<b>" + render(text) + "</b>";
                            }
                        }});
                    domains.html(rendered);

                    resultData.domains.forEach(function (domain, index) {

                        $('#domain' + domain.id + '-select-all').click(function (e) {
                            $('input:checkbox[id^="domain'+domain.id+'-"]').prop('checked', true);
                        });

                        $('#domain' + domain.id + '-clear-all').click(function (e) {
                            $('input:checkbox[id^="domain' + domain.id + '-"]').prop('checked', false);
                        });
                    });

                    $('.hideUntilLoaded').show();
                },
                error: function (result) {
                    console.log(result);
                }
            });

            $('#view-activities-indicators').on('click', function (e) {
                var ids = [];
                $('#domains input[type="checkbox"]').each(function (i) {
                    if ($(this).is(":checked")) {
                        ids.push($(this).val());
                    }
                });

                $('#outcomeIds').val(ids);

            });

            var filterData = null;
            $.ajax({
                url: '/umbraco/surface/medb/outcomessearchmetadata',
                type: 'GET',
                dataType: 'json',
                success: function (data) {
                    // load select lists.
                    console.log(data)
                    filterData = data;
                },
                error: function (result) {
                    console.log(result);
                },
                complete: function (jqXHR, textStatus) {
                    // enable search btn
                    if (textStatus == "success") {
                        self.buildSelect('#domain', filterData.domains);
                        self.buildSelect('#disaster_type', filterData.disaster_types);
                        self.buildSelect('#jurisdiction', filterData.jurisdictions);
                        self.buildSelect('#indicator_category', filterData.categories);
                    }

                    // set select2 links
                    var settings = {
                        placeholder: "All",
                        allowClear: false,
                        width: '100%'
                    }

                    $('#domain, #disaster_type, #jurisdiction, #indicator_category').select2(settings);
                }
            });

        },
        initSearchResultsForm: function () {
            var self = this;

            // Set the hide show filter functionality
            $('#hide_show_filters').on('click', function (e) {
                e.preventDefault();
                self.toggleFilters();
            })
           

            var filterData = null;

            $.ajax({
                url: '/umbraco/surface/medb/outcomessearchmetadata',
                type: 'GET',
                dataType: 'json',
                success: function (data) {
                    // load select lists.
                    console.log(data)
                    filterData = data;
                },
                error: function (result) {
                    console.log(result);
                },
                complete: function (jqXHR, textStatus) {
                    // enable search btn
                    if (textStatus == "success") {
                        self.buildSelect('#domain', filterData.domains);
                        self.buildSelect('#disaster_type', filterData.disaster_types);
                        self.buildSelect('#jurisdiction', filterData.jurisdictions);
                        self.buildSelect('#indicator_category', filterData.categories);
                    }
                    
                    // set select2 links
                    var settings = {
                        placeholder: "All",
                        allowClear: false,
                        width: '100%'
                    }

                    $('#domain, #disaster_type, #jurisdiction, #indicator_category').each(function () {
                        let select2 = $(this).select2(settings);
                        // Set initial values.
                        if ($(this).attr('initialval')) {
                            let vals = $(this).attr('initialval').split(',');
                            select2.val(vals);
                            select2.trigger('change');
                        }
                    });

                    // Textboxes.
                    $('#date_from, #date_to').each(function () {
                        $(this).val($(this).attr('initialval'));
                    });

                    //$('.meDbSearch__row').hide(); // hide filters.

                    $('.meDbSearch__form .btnArea button[type=submit]:first').click();
                }
            });

            $(".meDbSearch__form").submit(function (e) {
                e.preventDefault();
                var formData = self.getFormData();
                self.search(formData);
            });

            $("#clear-filters").click(function (e) {
                e.preventDefault();
                $("#disaster_name").val(null);
                $('#disaster_type').val([]).trigger("change");
                $('#jurisdiction').val([]).trigger("change");
                $('#domain').val([]).trigger("change");
                $('#indicator_category').val([]).trigger("change");
                $('#date_from').val(null);
                $('#date_to').val(null);
            });
            
           function base64ToArrayBuffer(base64) {
                var binaryString = window.atob(base64);
                var binaryLen = binaryString.length;
                var bytes = new Uint8Array(binaryLen);
                for (var i = 0; i < binaryLen; i++) {
                    var ascii = binaryString.charCodeAt(i);
                    bytes[i] = ascii;
                }
                return bytes;
            }

		   function saveByteArray(reportName, byte) {

				var blob = new Blob([byte], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" });
				var fileName = reportName + ".xlsx";
				var link = document.createElement("a");
				document.body.appendChild(link)

				if (window.navigator.msSaveOrOpenBlob) {
					window.navigator.msSaveOrOpenBlob(new Blob([byte]), fileName);
				} else {
					link.href = window.URL.createObjectURL(blob);
					link.download = fileName;
					link.click();
				}
            }

            $('#export-excel').on('click', function (e) {

                var formData = self.getFormData();

                // get field loader data from API cached calls.
                $.ajax({
                    url: '/umbraco/surface/medb/outcomessearchexportexcel',
                    type: 'POST',
                    contentType: 'application/json; charset=utf-8',
                    data: JSON.stringify(formData),
                    success: function (data) {
                        var sampleArr = base64ToArrayBuffer(data.base64str);
                        saveByteArray("AIDR Recovery Outcomes - Activities and Indicators", sampleArr);
                    },
                    error: function (result) {
                        console.log(result);
                    }
                });
            });

            //var formData = self.getFormData();
            //self.search(formData);
        },
        initTabs: function () {
            $(".meDbOutcomesSearch__form").on('click', '.meDbOutcomesSearch__form__tabs a', function (e) {
                e.preventDefault();
                e.stopPropagation();
                //location.hash = $(this).attr('data-hashname');
                var target = $(this).attr('data-tab');
                if (target && target != '') {
                    $('.meDbOutcomesSearch__form__tabs__tab').removeClass('selected');
                    $(this).parent().addClass('selected');
                    $('.meDbOutcomesSearch__form__tabContent').hide();
                    $('#'+ target).show();
                }
            });

            $('.meDbOutcomesSearch__spinner').bind('start', function () {
                $(this).show();
                $('.meDbOutcomesSearch__form').hide();
                if (window.meDbOutcomesSearch__spinner) {
                    window.meDbOutcomesSearch__spinner.spin($(this).get(0));
                } else {
                    window.meDbOutcomesSearch__spinner = new window.Spinner().spin($(this).get(0));
                }
            });
            $('.meDbOutcomesSearch__spinner').bind('stop', function () {
                // Only stop the spinner if all tabs have finished loading.
                if ($('#activitiesCount').text().trim() && $('#indicatorsCount').text().trim() && $('#resourcesCount').text().trim()) {
                    $(this).hide();
                    $('.meDbOutcomesSearch__form').show();
                    window.meDbOutcomesSearch__spinner.stop();
                }

                /*
                // Restore state of last tab.
                let lastHashName = location.hash.substring(1);
                if (lastHashName) {
                    $('.meDbOutcomesSearch__form__tabs a[data-hashname="' + lastHashName + '"]').click();
                }
                */
            });
        },
        buildSelect: function (id, jsonData) {

            // Load up the tags filter with the tags from the 
            $(id).empty().append($('<option>', {
                value: '',
                text: 'All tags'
            }));

            $.each(jsonData, function (i, value) {
                $(id).append($('<option>', {
                    value: value.id,
                    text: value.title
                }));
            });

        },
        getFormData: function () {
            var form = {
                outcomes: $.map($('#outcomeIds').val().split(',').filter(function (x) { return x; }), function (value) {
                    return parseInt(value, 10);
                }),
                name: $('#disaster_name').val(),
                disasterTypes: $('#disaster_type').val(),
                jurisdictions: $('#jurisdiction').val(),
                dateFrom: $('#date_from').val().length > 0 ? $('#date_from').val() + '-12-31' : '',
                dateTo: $('#date_to').val().length > 0 ? $('#date_to').val() + '-01-01' : '',
                categories: $('#indicator_category').val(),
                domains: $('#domain').val()
            }

            return form;
        },
        search: function (formData) {
            var self = this;

            var resultData = null;
            $('#activitiesCount, #indicatorsCount, #resourcesCount').html('');
            $('.meDbOutcomesSearch__spinner').triggerHandler('start');

            // get field loader data from API cached calls.
            $.ajax({
                url: '/umbraco/surface/medb/outcomessearch',
                type: 'POST',
                contentType: 'application/json; charset=utf-8',
                dataType: 'json',
                data: JSON.stringify(formData),
                success: function (data) {

                    // load select lists.
                    console.log(data)
                    resultData = data;

                    // Load the activities
                    var activities = $('#resultsActivitiesList');
                    activities.empty();

                    // Load the indicators
                    var indicators = $('#resultsIndicatorsList');
                    indicators.empty();

                    $('#activitiesCount').text(resultData.activities_count);
                    $('#indicatorsCount').text(resultData.indicators_count);

                    if (resultData.activities_count <= 0) {
                        resultData.outcomes_activities.push({ "outcome_id": "0", "outcome_title": "Your search returned no activities.", "activities": [] });
                    }

                    var templateActivities = $('.meDbOutcomesSearch__activities > script').html();
                    mustache.parse(templateActivities);
                    var renderedActivities = mustache.render(templateActivities, { outcomes_activities: resultData.outcomes_activities });
                    activities.html(renderedActivities);

                    if (resultData.indicators_count <= 0) {
                        resultData.outcomes_indicators.push({ "outcome_id": "0", "outcome_title": "Your search returned no activities.", "indicators": [] });
                    }

                    var templateIndicators = $('.meDbOutcomesSearch__indicators > script').html();
                    mustache.parse(templateIndicators);
                    var renderedIndicators = mustache.render(templateIndicators, { outcomes_indicators: resultData.outcomes_indicators });
                    indicators.html(renderedIndicators);

                    $('.meDbOutcomesSearch__spinner').triggerHandler('stop');
                },
                error: function (result) {
                    console.log(result);
                }
            });
        }
    };
});